<hbox class="mail-start-page">
</hbox>

<script lang="ts">
  import { t } from "../../l10n/l10n";
</script>

<style>
  .mail-start-page {
    align-items: center;
    justify-content: center;
    padding-block-start: 5em;
  }
</style>
